export default {
  SEARCH: {
    NO_MATCH: 'There are no medications that match your search...',
    NO_DATA: 'Medication search results shown here...'
  },
  MEDICATIONS: {
    ERROR: 'There was an issue fetching medications.',
    NO_DATA: 'No medications selected...'
  },
  UPDATE_ERROR: {
    severity: 'error' as 'error',
    title: 'Uh oh!',
    subtitle: 'There was an issue updating your medication'
  }
};
